<template>
  <div
    :class="rowClasses"
    :style="rowStyle"
  >
    <slot></slot>
  </div>
</template>
<script>
import { NAME_PRE } from '@/packages/constant/index';

export default {
  name: `${NAME_PRE}-row`,

  props: {
    gutter: {
      type: Number,
      default: 0,
    },

    justify: {
      type: String,
      validator(type) {
        let types = ['start', 'end', 'center', 'space-around', 'space-between'];
        if (type && !types.includes(type)) {
          console.error(`justify的传值必须是${types.join('、')}当中的一个`);
        }
        return true;
      },
    },
  },

  data() {
    return {};
  },

  computed: {
    rowStyle() {
      let style = {};
      if (this.gutter) {
        // 通过拉长这个row的长度来 去掉col第一个和最后一个的padding
        style = {
          ...style,
          marginLeft: `${-this.gutter / 2}px`,
          marginRight: `${-this.gutter / 2}px`,
        };
      }

      if (this.justify) {
        let key = ['start', 'end'].includes(this.justify)
          ? `flex-${this.justify}`
          : this.justify;
        style = {
          ...style,
          justifyContent: key,
        };
      }
      return style;
    },

    rowClasses() {
      let rowClasses = [`${NAME_PRE}-row`];
      return rowClasses;
    }
  },

  mounted() {
    this.setColGutter();
  },

  methods: {
    setColGutter() {
      // 给col赋值gutter
      this.$children.forEach((child) => {
        child.gutter = this.gutter;
      });
    },
  },
};
</script>
